import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import {
  Savings,
  Security,
  CreditCard,
  SupportAgent,
  ShowChart,
  CurrencyBitcoin,
} from "@mui/icons-material";
import { motion } from "framer-motion";

const services = [
  {
    title: "Fast & Secure Transfers",
    description: "Send and receive money instantly with top-grade encryption.",
    icon: <Security />,
  },
  {
    title: "Virtual & Physical Cards",
    description: "Shop globally using your digital or physical FentrixBank card.",
    icon: <CreditCard />,
  },
  {
    title: "Automated Savings Vault",
    description: "Set goals and watch your money grow automatically.",
    icon: <Savings />,
  },
  {
    title: "Crypto Wallet Integration",
    description: "Buy, hold, and manage crypto — right inside your dashboard.",
    icon: <CurrencyBitcoin />,
  },
  {
    title: "24/7 Customer Support",
    description: "Get instant help anytime from our world-class support team.",
    icon: <SupportAgent />,
  },
  {
    title: "Expense Tracking",
    description: "See where your money goes with real-time analytics.",
    icon: <ShowChart />,
  },
];

export default function Services() {
  return (
    <Box className="w-full bg-black text-white py-20 overflow-hidden">
      <Container>

        {/* Title */}
        <Typography
          className="text-center font-bold mb-12"
          sx={{
            fontSize: { xs: "2rem", md: "2.8rem" },
            background:
              "linear-gradient(to right, #00B4D8, #FF4EC5)",
            WebkitBackgroundClip: "text",
            color: "transparent",
          }}
        >
          Our Banking Services
        </Typography>

        <Grid container spacing={6}>

          {/* Illustration */}
          <Grid item xs={12} md={5}>
            <Box
              component="img"
              src="/assets/employee-engagement-concept-illustration.png"
              alt="Bank Illustration"
              sx={{
                width: "100%",
                maxWidth: 480,
                display: "block",
                mx: "auto",
                filter: "drop-shadow(0 0 25px rgba(0,180,216,0.25))",
              }}
            />
          </Grid>

          {/* Service Cards */}
          <Grid item xs={12} md={7}>
            <Grid container spacing={4}>
              {services.map((service, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                  >
                    <Card
                      sx={{
                        background: "#101010",
                        border: "1px solid #1a1a1d",
                        borderRadius: "18px",
                        p: 1,
                        height: "100%",
                        boxShadow:
                          "0 0 15px rgba(0,180,216,0.15), 0 0 15px rgba(255,78,197,0.05)",
                        transition: "0.3s",
                        "&:hover": {
                          boxShadow:
                            "0 0 25px rgba(0,180,216,0.35), 0 0 25px rgba(255,78,197,0.25)",
                          transform: "translateY(-6px)",
                        },
                      }}
                    >
                      <CardContent>
                        <Box
                          sx={{
                            width: 65,
                            height: 65,
                            borderRadius: "50%",
                            mx: "auto",
                            mb: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background:
                              "linear-gradient(135deg, #00B4D8, #FF4EC5)",
                            color: "white",
                            boxShadow: "0 0 20px rgba(0,180,216,0.3)",
                          }}
                        >
                          {service.icon}
                        </Box>

                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          textAlign="center"
                          gutterBottom
                          sx={{ color: "#fff" }}
                        >
                          {service.title}
                        </Typography>

                        <Typography
                          variant="body2"
                          textAlign="center"
                          sx={{ color: "#9ca3af" }}
                        >
                          {service.description}
                        </Typography>
                      </CardContent>
                    </Card>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}